import { FC, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdCard from "../../components/Card/AdCard";
import { AdData, AdDataType } from "../../utils/data";

const MyAdContent: FC = () => {
  const cardsArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

  return (
    <div className=" grid gap-5 sm:grid-cols-2 lg:grid-cols-4 h-full flex">
      {AdData.map((data: AdDataType, index: number) => {
        return (
          <Link to={`/ad/${data.id}`} key={index}>
            <div className="flex flex-col justify-between overflow-hidden text-left transition-shadow duration-200 bg-white rounded-xl shadow-xl group hover:shadow-2xl cursor-pointer">
              <div className="flex flex-col justify-between overflow-hidden text-left transition-shadow duration-200 bg-white rounded-xl shadow-xl group hover:shadow-2xl">
                <AdCard adData={data} />
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default MyAdContent;
